export default __webpack_public_path__ + "static/media/boy3.a46b5f81.svg";